import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import errorHandler from "@/layout/components/error/ErrorHandler";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../helpers/Translator";
import useIsMounted from "../../hooks/useIsMounted";

export default function NoteSelect(props) {
  const {
    value,
    onHandleChange,
    className = "mb-2",
    isMulti = true,
    allowSelectAll = true,
    hasSearchBox = false,
    hasSelectOptions = false,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [notes, setNotes] = useState();

  // > LOAD NOTES //
  const loadNotes = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            plantHex
              ? "api_r_user_module_legalCompliance_evaluation_getNotes"
              : "api_r_user_module_globalLegalCompliance_evaluation_getNotes"
          ),
          { moduleBridgeHex, plantHex }
        )
        .then((r) => {
          if (isMounted.current) {
            setNotes(r.data);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex, plantHex]
  );

  useEffect(() => {
    loadNotes();
  }, []);
  // < LOAD NOTES //

  return (
    <AppMultiSelect
      options={notes}
      title={ReactDOMServer.renderToString(
        <Translator file="evaluation" name="note.title" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="select.one.or.multiple.notes"
        />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="apps-2" />}
      allowSelectAll
      isLoading={!notes}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
    />
  );
}
